// eslint-disable-next-line no-restricted-imports
import Dinero from 'dinero.js';

export { Dinero };
